export enum ENUM_ACCORDION_TYPES {
  OPEN = "open",
  CLOSED = "closed",
}
